var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "top", appear: "" } },
    [
      _c(
        "q-page-sticky",
        { attrs: { position: "top-right", offset: [18, 18] } },
        [
          _c(
            "q-btn",
            {
              attrs: {
                round: "",
                outline: "",
                color: "primary",
                icon: "clear"
              },
              on: { click: _vm.goView }
            },
            [
              _c(
                "q-tooltip",
                {
                  attrs: {
                    self: "center right",
                    anchor: "center left",
                    delay: 500
                  }
                },
                [_vm._v("Отменить")]
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.type || _vm.type === "d"
            ? _c(
                "q-btn",
                {
                  attrs: {
                    round: "",
                    color: "warning",
                    disabled: _vm.notChanged && _vm.type !== "a"
                  },
                  on: { click: _vm.doSave }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      attrs: {
                        self: "center right",
                        anchor: "center left",
                        delay: 500
                      }
                    },
                    [_vm._v("Сохранить как черновик")]
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("✓")]),
                  _vm._v(" "),
                  _c("q-icon", {
                    attrs: { name: "far fa-file-alt", size: "15px" }
                  })
                ],
                1
              )
            : _c(
                "q-btn",
                {
                  attrs: {
                    round: "",
                    color: "warning",
                    disabled: _vm.notChanged && _vm.type !== "a"
                  },
                  on: { click: _vm.doSave }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      attrs: {
                        self: "center right",
                        anchor: "center left",
                        delay: 500
                      }
                    },
                    [_vm._v("Сохранить как черновик")]
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("✓")]),
                  _vm._v(" "),
                  _c("q-icon", {
                    attrs: { name: "far fa-file-alt", size: "15px" }
                  })
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "q-btn",
            {
              attrs: {
                round: "",
                color: "primary",
                disabled: _vm.notChanged && _vm.type !== "d" && _vm.type !== "v"
              },
              on: { click: _vm.doPublish }
            },
            [
              _c(
                "q-tooltip",
                {
                  attrs: {
                    self: "center right",
                    anchor: "center left",
                    delay: 500
                  }
                },
                [_vm._v("Опубликовать")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v("✓")]),
              _vm._v(" "),
              _c("q-icon", { attrs: { name: "fas fa-file-alt", size: "15px" } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(">\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-587e69de", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587e69de","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publish-btn.vue
// module id = null
// module chunks = 